import React, { Component } from 'react'
import Styled from 'styled-components'
import throttle from 'lodash/throttle'
import deepEqual from 'deep-equal'

import {
  DEVICE_VIEWPORT_RESOLUTIONS
} from 'shared/enums/index'

const Container = Styled.div``

const Canvas = Styled.div`
  width: ${props => props.viewport.resolution.width * props.viewport.scale}px;
  height: ${props => props.viewport.resolution.height * props.viewport.scale}px;
  overflow: hidden;
`

const Viewport = Styled.div`
  background: #fff;
  width: ${props => props.viewport.resolution.width}px;
  transform: scale(${props => props.viewport.scale});
  transform-origin: 0 0;
`

export default class extends Component {
  state = {
    viewport: {
      resolution: {
        width: DEVICE_VIEWPORT_RESOLUTIONS[this.props.device].width,
        height: DEVICE_VIEWPORT_RESOLUTIONS[this.props.device].height
      },
      scale: 1
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleAdjustSizeThrottled, false)
    this.handleAdjustSize()
  }

  componentDidUpdate() {
    this.handleAdjustSize()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleAdjustSizeThrottled, false)
    this.handleAdjustSizeThrottled.cancel()
  }

  handleAdjustSizeThrottled = throttle(() => {
    this.handleAdjustSize()
  }, 250, { leading: true, trailing: true })

  handleAdjustSize = () => {
    if (!this.$container) return

    const maxWidth = this.props.containerId
      ? document.getElementById(this.props.containerId).offsetWidth
      : this.$container.offsetWidth

    const deviceViewport = {
      resolution: {
        width: DEVICE_VIEWPORT_RESOLUTIONS[this.props.device].width,
        height: DEVICE_VIEWPORT_RESOLUTIONS[this.props.device].height
      }
    }

    const scale = maxWidth >= deviceViewport.resolution.width
      ? 1
      : Math.floor((maxWidth / deviceViewport.resolution.width) * 100) / 100

    const width = deviceViewport.resolution.width
    const height = this.$viewport.offsetHeight

    const viewport = {
      resolution: {
        width,
        height
      },
      scale
    }

    if (!deepEqual(this.state.viewport, viewport)) {
      this.setState({ viewport })
    }
  }

  render() {
    return (
      <Container
        ref={(e) => { this.$container = e }}
      >
        <Canvas
          viewport={this.state.viewport}
        >
          <Viewport
            viewport={this.state.viewport}
            ref={(e) => { this.$viewport = e }}
          >
            {this.props.children}
          </Viewport>
        </Canvas>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Viewport/index.js